@if (visible()) {
  <div class="analysts-overview" [class.desktop]="isDesktop()">
    <app-v3-overview-card-header
      icon="/v3/profile.svg"
      title="Analysten"
      [updatedAt]="updatedAt()"
      actionLabel="Alle Analysten"
      (navigate)="onNavigate()"
    ></app-v3-overview-card-header>

    @if (isDesktop()) {
      <app-v3-analysts-desktop-content
        [currentPrice]="currentPrice()"
      ></app-v3-analysts-desktop-content>
    } @else {
      @if (hasContent()) {
        <app-v3-analysts-stats-row
          [gaugeValue]="gaugeValue()"
          [sellGaugeValue]="sellGaugeValue()"
          [isPositive]="isPositive()"
          [rating]="rating()"
          [buyCount]="buyCount()"
          [holdCount]="holdCount()"
          [sellCount]="sellCount()"
          [potential]="potential()"
        ></app-v3-analysts-stats-row>

        @if (theses().length > 0) {
          <div class="thesis-header">
            <span class="thesis-icon" [class.negative]="!isPositive()"></span>
            <span class="thesis-title" [class.negative]="!isPositive()">
              {{ isPositive() ? 'Positive Thesen' : 'Negative Thesen' }}
            </span>
          </div>

          <div class="thesis-list">
            @for (thesis of theses(); track thesis.title; let i = $index) {
              <div class="thesis-item">
                <button
                  class="thesis-row"
                  type="button"
                  [attr.aria-expanded]="expandedIndex() === i"
                  (click)="toggleThesis(i)"
                >
                  <span class="thesis-icon" [class.negative]="!isPositive()"></span>
                  <span class="thesis-row-title">{{ thesis.title }}</span>
                  <span class="thesis-chevron" [class.expanded]="expandedIndex() === i"></span>
                </button>
                @if (expandedIndex() === i) {
                  <p class="thesis-body">{{ thesis.text }}</p>
                }
              </div>
            }
          </div>
        }
      }

      @if (isFinnet()) {
        <button class="analysts-details" type="button" (click)="onNavigate()">
          <span>Prognosen der Analysten</span>
          <span class="caret"></span>
        </button>
      }
    }
  </div>
}
